import { useDisclosure } from '@mantine/hooks';
import React from 'react';
import { NavLink, useParams } from 'react-router-dom';

import { rootRoutes } from '../../../../app/routers/rootRoutes';
import { useAppSelector } from '../../../../app/stores/hooks';
import { selectSort, TaskGroups, taskGroups, useGetTaskListQuery } from '../../../../entities/tasks';
import { selectFilteredTasks } from '../../../../entities/tasks/model/selectors/task-list';
import { ReactComponent as Hamburger } from '../../../../shared/assets/hamburger.svg';
import { ReactComponent as Search } from '../../../../shared/assets/search.svg';
import { texts } from '../../../../shared/config';
import { ContentLayout } from '../../../../shared/ui/ContentLayout';
import { GroupedTaskNavigation } from '../../../../shared/ui/GroupedTaskNavigation';
import { Header } from '../../../../shared/ui/Header';
import { LinearProgress } from '../../../../shared/ui/LinearProgress';
import { Message } from '../../../../shared/ui/Message';
import { TaskMenu } from '../../../../shared/ui/TaskMenu';

const getGroup = (groupId?: string) => {
  return groupId ? (taskGroups[groupId] ?? TaskGroups.None) : TaskGroups.None;
};

export const GroupedTasks: React.FC = () => {
  const params = useParams();
  const [opened, { open, close }] = useDisclosure(false);

  const sort = useAppSelector(selectSort);
  const groupId = getGroup(params.groupId);

  const settings = React.useMemo(() => ({ groupId, sort }), [groupId, sort]);

  const { filteredData, isError, isFetching, isSuccess } = useGetTaskListQuery(undefined, {
    selectFromResult: (result) => ({
      ...result,
      filteredData: selectFilteredTasks(result, settings),
    }),
  });

  return (
    <>
      <Header
        leftIcon={<Hamburger onClick={open} />}
        rightIcon={
          <NavLink to={rootRoutes.search} end>
            <Search />
          </NavLink>
        }
      >
        Задачи
      </Header>

      {isFetching && <LinearProgress position="absolute" />}

      <ContentLayout dataId="groupedTasksList">
        {isSuccess && (
          <>
            {filteredData.groupKeys.length ? (
              <GroupedTaskNavigation
                countsMap={filteredData.countsMap}
                groupId={groupId}
                groupKeys={filteredData.groupKeys}
              />
            ) : (
              <Message title="Нет задач, соответствующих запросу" />
            )}
          </>
        )}
        {isError && <Message title={texts.defaultError} />}
      </ContentLayout>
      <TaskMenu opened={opened} onClose={close} />
    </>
  );
};
